import * as angular from 'angular';
import { bind } from 'app/_decorators/bind.decorator';
import { StorageEnums } from 'app/storage-offer/storage-enum-values';

class StorageCapacityFormComponentCtrl implements ng.IController {
    public model: ng.INgModelController;
    public innerModel: StorageQuantityDto;
    public innerModelforDisabledForm: string;
    public enums = StorageEnums;
    private listType: any;
    private defaultUnit: any;

    constructor(private $filter: ng.IFilterService) {}

    $onInit(): void {
        if (!this.listType) {
            this.listType = this.enums.storageQuantityUnitValues;
        }

        if (!this.defaultUnit) {
            this.innerModel = {
                value: null,
                unit: 'KWH_H'
            };
        } else {
            this.innerModel = {
                value: null,
                unit: this.defaultUnit
            };
        }

        this.model.$formatters.push(this.convertToViewValue);
        this.model.$parsers.push(this.convertToModelValue);
    }

    @bind
    private convertToViewValue(
        modelValue: StorageQuantityDto
    ): StorageQuantityDto {
        if (!modelValue) {
            this.innerModel.value = null;
        } else {
            this.innerModel.value = modelValue.value;
            this.innerModel.unit = modelValue.unit;
        }
        return this.innerModel;
    }

    @bind
    private convertToModelValue(
        viewValue: StorageQuantityDto
    ): StorageQuantityDto {
        if (viewValue.value === null) {
            return null;
        }

        if (angular.isUndefined(viewValue.value)) {
            return undefined;
        }

        if (viewValue.value === null) {
            return null;
        }

        return this.innerModel;
    }

    public updateValue(value: number): void {
        this.innerModel.value = value;
        this.innerModelforDisabledForm = this.$filter('number')(value);
        this.model.$setViewValue(angular.copy(this.innerModel));
    }

    public updateQuantity(unit: StorageQuantityUnit): void {
        this.innerModel.unit = unit;
        this.model.$setViewValue(angular.copy(this.innerModel));
    }
}

angular.module('app').component('pkpStorageCapacityForm', {
    require: {
        model: 'ngModel'
    },
    controller: StorageCapacityFormComponentCtrl,
    template: require('app/storage-offer/storage-capacity-form.component.html'),
    bindings: {
        componentDisabled: '<',
        componentPlaceholder: '<',
        listType: '<?',
        defaultUnit: '<?'
    }
});
